export default function appPercent (input: string, ignoreValues: string[] = []) {
  if (!input) return
  if (ignoreValues.includes(input)) return input
  return input + '%'
}
